import React from "react";
import { Phone, PhoneOff, User } from "lucide-react";
import { apiClient } from "../../lib/api";

const KIND_LABEL = { driver: "Driver", rider: "Rider", tp: "Transport provider", crm: "Contact", staff: "Teammate", transfer: "Transferred call", unknown: "Caller" };

export const IncomingCallPopup = ({ incoming, onAnswer, dismiss, busy }) => {
  if (!incoming.length) return null;
  const c = incoming[0];
  const decline = async () => {
    dismiss(c.id);
    apiClient.post(`/softphone/incoming/${c.id}/decline`, { source: c.source }).catch(() => {});
  };
  return (
    <div className="sp-incoming" data-testid="softphone-incoming-popup" role="alertdialog" aria-label="Incoming call">
      <div className="sp-incoming-pulse"><User size={22} /></div>
      <div className="sp-incoming-body">
        <div className="sp-incoming-label">Incoming call · {KIND_LABEL[c.kind] || "Caller"}</div>
        <div className="sp-incoming-name" data-testid="softphone-incoming-name">{c.name}</div>
        {c.phone && <div className="sp-incoming-phone" data-testid="softphone-incoming-phone">{c.phone}</div>}
        {c.summary && <div className="sp-incoming-summary">{c.summary}</div>}
        {incoming.length > 1 && <div className="sp-incoming-more">+{incoming.length - 1} more ringing</div>}
      </div>
      <div className="sp-incoming-actions">
        <button className="sp-btn-round sp-red" onClick={decline} data-testid="softphone-decline-btn" title="Decline"><PhoneOff size={18} /></button>
        <button className="sp-btn-round sp-green" disabled={busy} onClick={() => { dismiss(c.id); onAnswer(c); }} data-testid="softphone-answer-btn" title="Answer"><Phone size={18} /></button>
      </div>
    </div>
  );
};
